import { LocationFieldDataType } from './dataType';
import { GeoJSONGeometry } from './geojson';

export enum LocationDataTitle {
  MANAGEMENT_UNIT = 'Management Unit',
  COUNTY = 'County',
  ROAD_CLASS = 'Road Class',
  ROUTE = 'Route',
  DIRECTION = 'Direction',
  STATION = 'Station',
  START_MILEPOST = 'Start Milepost',
  END_MILEPOST = 'End Milepost',
}

export interface LocationDataState {
  [LocationDataTitle.MANAGEMENT_UNIT]?: string;
  [LocationDataTitle.COUNTY]?: string;
  [LocationDataTitle.ROAD_CLASS]?: string;
  [LocationDataTitle.ROUTE]?: string;
  [LocationDataTitle.DIRECTION]?: string;
  [LocationDataTitle.STATION]?: string;
  [LocationDataTitle.START_MILEPOST]?: any;
  [LocationDataTitle.END_MILEPOST]?: any;
}

// Key is dropdown title, value is current enumeration value
// START_MILEPOST and END_MILEPOST are exceptions, representing min and max values
export interface LocationOptionsState {
  [LocationDataTitle.MANAGEMENT_UNIT]?: string[];
  [LocationDataTitle.COUNTY]?: string[];
  [LocationDataTitle.ROAD_CLASS]?: string[];
  [LocationDataTitle.ROUTE]?: string[];
  [LocationDataTitle.DIRECTION]?: string[];
  [LocationDataTitle.STATION]?: string[];
  [LocationDataTitle.START_MILEPOST]?: any;
  [LocationDataTitle.END_MILEPOST]?: any;
}

export interface LocationDataItem {
  title: string;
  dataType: LocationFieldDataType;
  enumeration?: string[];
  value?: any;
}

export interface TaskLocation {
  id: string;
  workOrderId: string;
  taskId: string;
  name: string;
  geometry: any;
  data?: LocationDataItem[];
  createdDate?: number;
  createdBy?: string;
  updatedDate?: number;
  updatedBy?: string;
}

export interface TaskLocationsConnection {
  totalCount: number;
  taskLocations: TaskLocation[];
}

export interface TaskLocationAutocomplete {
  components?: LocationDataItem[];
  minMilePost?: number;
  maxMilePost?: number;
}

export interface TaskLocationFind {
  name: string;
  geometry: GeoJSONGeometry;
}

export interface TaskLocationsConnectionInput {
  ids: string[];
}

export interface TaskLocationCreateInput {
  workOrderId: string;
  taskId: string;
  name: string;
  geometry: GeoJSONGeometry;
  data?: LocationDataItem[];
}

export interface TaskLocationUpdateInput {
  id: string;
  name?: string;
  geometry?: GeoJSONGeometry;
  data?: LocationDataItem[];
}

export interface TaskLocationSimpleInputItem {
  name: string;
  value: string;
}

export interface TaskLocationSimpleInput {
  data?: TaskLocationSimpleInputItem[];
}
